function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M71.3616 51.0606H27.3687C24.8769 51.0606 22.857 49.0407 22.857 46.5489V19.1023C22.857 16.6104 24.8769 14.5905 27.3687 14.5905H71.3616C73.8534 14.5905 75.8733 16.6104 75.8733 19.1023V46.5489C75.8733 49.0405 73.8534 51.0606 71.3616 51.0606Z",
  fill: "#F4FBFF"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M71.3674 14.5905H70.2487V43.8581C70.2487 44.7294 69.5423 45.4358 68.6709 45.4358H22.857V46.5546C22.857 49.0431 24.8743 51.0606 27.363 51.0606H71.3674C73.8559 51.0606 75.8734 49.0432 75.8734 46.5546V19.0964C75.8733 16.6079 73.8559 14.5905 71.3674 14.5905Z",
  fill: "#D9D9DC"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M54.2142 24.143H76.2142V34.3573H54.2142V24.143Z",
  fill: "#535B6C"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M49.6309 38.4094H5.63791C3.14609 38.4094 1.12619 36.3895 1.12619 33.8977V6.45122C1.12619 3.9594 3.14609 1.93951 5.63791 1.93951H49.6308C52.1226 1.93951 54.1425 3.9594 54.1425 6.45122V33.8977C54.1426 36.3895 52.1226 38.4094 49.6309 38.4094Z",
  fill: "white"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M49.6366 1.93917H48.5179V31.2067C48.5179 32.0781 47.8115 32.7844 46.9401 32.7844H1.12619V33.9032C1.12619 36.3917 3.14353 38.4092 5.63219 38.4092H49.6366C52.1252 38.4092 54.1427 36.3919 54.1427 33.9032V6.44517C54.1427 3.95666 52.1252 1.93917 49.6366 1.93917Z",
  fill: "#D9D9DC"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M18.0699 24.1954H9.37375C8.12791 24.1954 7.11789 23.1854 7.11789 21.9396V15.9104C7.11789 14.6646 8.12791 13.6546 9.37375 13.6546H18.0699C19.3158 13.6546 20.3258 14.6646 20.3258 15.9104V21.9396C20.3258 23.1854 19.3158 24.1954 18.0699 24.1954Z",
  fill: "#FFE07D"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M18.0728 13.6546H17.526V20.6446C17.526 21.0593 17.1897 21.3956 16.7749 21.3956H7.11789V21.9424C7.11789 23.1868 8.12656 24.1954 9.37089 24.1954H18.0728C19.3171 24.1954 20.3258 23.1868 20.3258 21.9424V15.9076C20.3258 14.6632 19.3171 13.6546 18.0728 13.6546Z",
  fill: "#FFD064"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M70.2485 23.8077H75.8733V34.5206H70.2485V23.8077Z",
  fill: "#2B4D66"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M71.3676 13.464H55.2693V6.44541C55.2693 3.33969 52.7426 0.812981 49.6369 0.812981H5.63243C2.52671 0.812981 0 3.33969 0 6.44541V9.78062C0 10.4028 0.50441 10.9071 1.12643 10.9071C1.74844 10.9071 2.25285 10.4026 2.25285 9.78062V6.44541C2.25285 4.58192 3.76879 3.06598 5.63228 3.06598H49.6367C51.5002 3.06598 53.0162 4.58192 53.0162 6.44541V33.9036C53.0162 35.7671 51.5002 37.283 49.6367 37.283H5.63243C3.76894 37.283 2.253 35.7671 2.253 33.9036V15.0411C2.253 14.419 1.74859 13.9147 1.12658 13.9147C0.504561 13.9147 0 14.419 0 15.0411V33.9036C0 37.0093 2.52671 39.536 5.63243 39.536H21.7307V46.5546C21.7307 49.6603 24.2574 52.187 27.3631 52.187H35.3158C35.9379 52.187 36.4422 51.6826 36.4422 51.0606C36.4422 50.4384 35.9378 49.9342 35.3158 49.9342H27.3631C25.4996 49.9342 23.9837 48.4182 23.9837 46.5547V39.5362H49.6369C52.1341 39.5362 54.2558 37.902 54.9917 35.6474H74.747V46.5547C74.747 48.4182 73.2311 49.9342 71.3676 49.9342H40.4868C39.8646 49.9342 39.3604 50.4386 39.3604 51.0606C39.3604 51.6828 39.8648 52.187 40.4868 52.187H71.3676C74.4733 52.187 77 49.6603 77 46.5546V19.0964C77 15.9907 74.4733 13.464 71.3676 13.464ZM74.747 22.6813H58.9297C58.3075 22.6813 57.8032 23.1857 57.8032 23.8077C57.8032 24.4297 58.3076 24.9341 58.9297 24.9341H74.747V33.3941H55.2693V15.717H71.3676C73.2311 15.717 74.747 17.2329 74.747 19.0964V22.6813Z",
  fill: "black"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M18.0729 12.5281H9.37099C7.5075 12.5281 5.99156 14.044 5.99156 15.9075V21.9424C5.99156 23.8059 7.5075 25.3218 9.37099 25.3218H18.0729C19.9364 25.3218 21.4523 23.8059 21.4523 21.9424V15.9075C21.4523 14.044 19.9364 12.5281 18.0729 12.5281ZM8.24456 21.9424V20.0566H9.739C10.3619 20.0566 10.8669 19.5516 10.8669 18.9287C10.8669 18.3058 10.3619 17.8008 9.739 17.8008H8.24456V15.9075C8.24456 15.2864 8.74988 14.7811 9.37099 14.7811H12.6133V23.069H9.37099C8.74988 23.069 8.24456 22.5637 8.24456 21.9424ZM18.0729 23.069H14.8691V14.7811H18.0729C18.694 14.7811 19.1993 15.2864 19.1993 15.9075V17.8008H17.5931C16.9702 17.8008 16.4652 18.3058 16.4652 18.9287C16.4652 19.5516 16.9702 20.0566 17.5931 20.0566H19.1993V21.9424C19.1995 22.5637 18.6942 23.069 18.0729 23.069Z",
  fill: "black"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M7.43612 28.4285C6.81395 28.4285 6.30969 28.9329 6.30969 29.5549C6.30969 30.1771 6.8141 30.6814 7.43612 30.6814H13.8539C14.4761 30.6814 14.9803 30.1769 14.9803 29.5549C14.9803 28.9328 14.4759 28.4285 13.8539 28.4285H7.43612Z",
  fill: "black"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M17.7034 29.5549C17.7034 30.1771 18.2078 30.6814 18.8298 30.6814H25.2476C25.8697 30.6814 26.374 30.1769 26.374 29.5549C26.374 28.9328 25.8696 28.4285 25.2476 28.4285H18.8298C18.2078 28.4285 17.7034 28.9328 17.7034 29.5549Z",
  fill: "black"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M36.6414 30.6813C37.2636 30.6813 37.7678 30.1769 37.7678 29.5549C37.7678 28.9327 37.2634 28.4285 36.6414 28.4285H30.2236C29.6015 28.4285 29.0972 28.9329 29.0972 29.5549C29.0972 30.177 29.6016 30.6813 30.2236 30.6813H36.6414Z",
  fill: "black"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M40.4901 29.5549C40.4901 30.1771 40.9945 30.6814 41.6166 30.6814H48.0343C48.6565 30.6814 49.1607 30.1769 49.1607 29.5549C49.1607 28.9328 48.6563 28.4285 48.0343 28.4285H41.6166C40.9945 28.4285 40.4901 28.9328 40.4901 29.5549Z",
  fill: "black"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M66.4274 41.6537C67.0495 41.6537 67.5538 41.1493 67.5538 40.5273C67.5538 39.9051 67.0494 39.4008 66.4274 39.4008H60.0096C59.3874 39.4008 58.8832 39.9052 58.8832 40.5273C58.8832 41.1494 59.3876 41.6537 60.0096 41.6537H66.4274Z",
  fill: "black"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M42.8219 7.59322C40.4313 7.59322 38.4866 9.53807 38.4866 11.9285C38.4866 14.3191 40.4315 16.264 42.8219 16.264C45.2125 16.264 47.1574 14.3191 47.1574 11.9285C47.1574 9.53807 45.2125 7.59322 42.8219 7.59322ZM42.8219 14.0111C41.6737 14.0111 40.7396 13.0769 40.7396 11.9287C40.7396 10.7804 41.6738 9.84623 42.8219 9.84623C43.9701 9.84623 44.9044 10.7804 44.9044 11.9287C44.9044 13.0769 43.9701 14.0111 42.8219 14.0111Z",
  fill: "black"
});

var SvgCreditCard = function SvgCreditCard(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 53,
    viewBox: "0 0 77 53",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCreditCard, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/creditCard.0cc65976.svg";
export { ForwardRef as ReactComponent };